import breadcrumbNav from './breadcrumb-nav.vue'
export default breadcrumbNav



// WEBPACK FOOTER //
// ./src/components/breadcrumb-nav/index.js